<template>
  <SetupStepper :steps="steps" />
</template>
<script setup>
import SetupStepper from '@/components/rateConnect/setup/SetupStepper.vue'
import { getRcSetupSteps } from '@/constants/rcSetupSteps'

const steps = getRcSetupSteps(1)
</script>
